// extracted by mini-css-extract-plugin
module.exports = {"button":"CharacterExportToRoll20_button_1m1Mh"};